'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIAbstractPopup = require('./UIAbstractPopup');

var _UIAbstractPopup2 = _interopRequireDefault(_UIAbstractPopup);

var _UIPopoverContent = require('./UIPopoverContent');

var _UIPopoverContent2 = _interopRequireDefault(_UIPopoverContent);

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _PlacementConstants = require('./PlacementConstants');

var _times = require('HubStyleTokens/times');

var _Functions = require('../core/Functions');

var _EventHandlers = require('../core/EventHandlers');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Placement = require('./utils/Placement');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var POPOVER_TRANSITION_TIMEOUT = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var UIPopover = _react2.default.createClass({
  displayName: 'UIPopover',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, (0, _underscore.omit)(_UIPopoverContent2.default.propTypes, 'hasRendered'), {
    arrowSize: _react.PropTypes.oneOf((0, _underscore.keys)(_UIPopoverArrow2.default.ARROW_SIZES)),
    autoPlacement: _UIAbstractPopup2.default.propTypes.autoPlacement,
    children: _react.PropTypes.element,
    closeOnOutsideClick: _react.PropTypes.bool.isRequired,
    content: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.shape({
      header: _react.PropTypes.node,
      body: _react.PropTypes.node,
      footer: _react.PropTypes.node
    })]).isRequired,
    _distanceAdjustment: _react.PropTypes.number,
    _insetAdjustment: _react.PropTypes.number,
    onFocusLeave: _react.PropTypes.func,
    onChangePlacement: _react.PropTypes.func,
    onCloseComplete: _react.PropTypes.func,
    onCloseStart: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    pinToConstraint: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]).isRequired,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    target: _react.PropTypes.instanceOf(HTMLElement),
    targetAttachment: _react.PropTypes.string.isRequired,
    _bodyElement: _react.PropTypes.instanceOf(HTMLElement),
    _useMutationObserver: _react.PropTypes.bool.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIPopoverContent2.default.defaultProps, {
      arrowSize: 'medium',
      autoPlacement: true,
      closeOnOutsideClick: true,
      _distanceAdjustment: 0,
      _insetAdjustment: 0,
      open: false,
      pinToConstraint: false,
      placement: 'top',
      targetAttachment: 'auto',
      _useMutationObserver: false
    });
  },
  getInitialState: function getInitialState() {
    return {
      placement: null,
      isVisible: false,
      hasRendered: false
    };
  },
  componentWillMount: function componentWillMount() {
    var _props = this.props,
        content = _props.content,
        open = _props.open;

    if (content && open) {
      // If we're initially open, we want to set `isVisible: true` before first
      // render. Otherwise, calling updateIsVisible is undesirable.
      this.updateIsVisible(this.props, true);
    }

    // Depending on our props, we may or may not start listening for outside clicks
    this.toggleOutsideClickListener(this.props);
  },
  componentDidMount: function componentDidMount() {
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({
      hasRendered: true
    });
    /* eslint-enable react/no-did-mount-set-state */
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    // If the placement prop is reset, clear our internal override.
    if (nextProps.placement !== this.props.placement) {
      this.setState({
        placement: null
      });
    }

    if (nextProps.open !== this.props.open || !!nextProps.content !== !!this.props.content) {
      this.updateIsVisible(nextProps, false);
    }

    // Depending on our new props, we may either start or stop listening for outside clicks
    this.toggleOutsideClickListener(nextProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.unlistenForOutsideClick();
    clearTimeout(this._leaveTransitionTimeout);
  },
  toggleOutsideClickListener: function toggleOutsideClickListener(props) {
    var closeOnOutsideClick = props.closeOnOutsideClick,
        open = props.open;

    if (closeOnOutsideClick && open) {
      this.listenForOutsideClick();
    } else {
      this.unlistenForOutsideClick();
    }
  },
  listenForOutsideClick: function listenForOutsideClick() {
    window.addEventListener('click', this.handleWindowClick);
  },
  unlistenForOutsideClick: function unlistenForOutsideClick() {
    window.removeEventListener('click', this.handleWindowClick);
  },
  handleWindowClick: function handleWindowClick(evt) {
    var _props2 = this.props,
        onOpenChange = _props2.onOpenChange,
        open = _props2.open,
        target = _props2.target;

    if (!open) {
      return;
    }
    // eslint-disable-next-line react/no-is-mounted
    if (!this.isMounted()) {
      return;
    }
    var clickTarget = evt.target;
    var tetherTarget = (0, _reactDom.findDOMNode)(target || this);
    var contentEl = (0, _reactDom.findDOMNode)(this._content);

    // Ignore the click if it's within our Tether target
    if (tetherTarget && tetherTarget.contains(clickTarget)) {
      return;
    }

    // Ignore the click if it's within our popover container
    if (contentEl && (0, _EventHandlers.isClickWithinContainer)(evt, contentEl)) {
      return;
    }

    // Otherwise, trigger close
    onOpenChange((0, _SyntheticEvent2.default)(false));
  },
  updateIsVisible: function updateIsVisible(props, isMountRender) {
    // Determine whether our UIAbstractPopup should be open or closed. We must
    // wait for our leave transition to complete before closing it.
    var animateOnMount = props.animateOnMount,
        animateOnToggle = props.animateOnToggle,
        content = props.content,
        onCloseStart = props.onCloseStart,
        onOpenStart = props.onOpenStart,
        open = props.open;


    var hasAnimation = isMountRender && animateOnMount || !isMountRender && animateOnToggle;
    var animationTransitionTimeout = hasAnimation ? POPOVER_TRANSITION_TIMEOUT : 0;

    if (content && open) {
      (0, _Functions.callIfPossible)(onOpenStart);
      this.setState({
        isVisible: true,
        placement: null
      });
      clearTimeout(this._leaveTransitionTimeout);
      this._leaveTransitionTimeout = null;
      setTimeout(this.onEnterComplete, animationTransitionTimeout);
    } else if (!this._leaveTransitionTimeout) {
      (0, _Functions.callIfPossible)(onCloseStart);
      this._leaveTransitionTimeout = setTimeout(this.onLeaveComplete, animationTransitionTimeout);
    }
  },
  onEnterComplete: function onEnterComplete() {
    var onOpenComplete = this.props.onOpenComplete;

    (0, _Functions.callIfPossible)(onOpenComplete);
  },
  onLeaveComplete: function onLeaveComplete() {
    /* eslint-disable react/no-is-mounted */
    var onCloseComplete = this.props.onCloseComplete;

    (0, _Functions.callIfPossible)(onCloseComplete);
    if (this.isMounted()) {
      this.setState({
        isVisible: false
      });
    }
    this._leaveTransitionTimeout = null;
    /* eslint-enable react/no-is-mounted */
  },
  getArrowParams: function getArrowParams() {
    return _UIPopoverArrow2.default.ARROW_SIZES[this.props.arrowSize];
  },
  getPlacement: function getPlacement() {
    return this.state.placement || this.props.placement;
  },
  handleTetherUpdate: function handleTetherUpdate(event) {
    // Adjust our placement state to reflect Tether's response to a constraint
    var _props3 = this.props,
        autoPlacement = _props3.autoPlacement,
        onChangePlacement = _props3.onChangePlacement;

    var oldPlacement = this.getPlacement();
    var newPlacementVert = autoPlacement === 'horiz' ? (0, _Placement.getVertPart)(oldPlacement) : event.targetAttachment.top;
    var newPlacementHoriz = autoPlacement === 'vert' ? (0, _Placement.getHorizPart)(oldPlacement) : event.targetAttachment.left;

    if (!newPlacementVert || !newPlacementHoriz) {
      // This indicates pinning, which we don't need to respond to
      return;
    }

    var newPlacement = null;
    if (newPlacementVert === 'middle') {
      newPlacement = newPlacementHoriz;
    } else if (newPlacementHoriz === 'center' || newPlacementHoriz === 'middle') {
      // #1942
      newPlacement = newPlacementVert;
    } else {
      newPlacement = newPlacementVert + ' ' + newPlacementHoriz;
    }

    if (this.state.placement !== newPlacement) {
      this.setState({
        placement: newPlacement
      });
      (0, _Functions.callIfPossible)(onChangePlacement, { newPlacement: newPlacement });
    }
  },
  reposition: function reposition() {
    if (this._popup) {
      this._popup.repositionTether();
    }
  },
  contentRefCallback: function contentRefCallback(ref) {
    this._content = ref;
  },
  popupRefCallback: function popupRefCallback(ref) {
    this._popup = ref;
  },
  renderPopoverContent: function renderPopoverContent() {
    var _props4 = this.props,
        animateOnMount = _props4.animateOnMount,
        animateOnToggle = _props4.animateOnToggle,
        content = _props4.content,
        id = _props4.id,
        open = _props4.open,
        arrowColor = _props4.arrowColor,
        arrowSize = _props4.arrowSize,
        className = _props4.className,
        style = _props4.style,
        use = _props4.use,
        width = _props4.width;
    var hasRendered = this.state.hasRendered;


    return _react2.default.createElement(_UIPopoverContent2.default, {
      animateOnMount: animateOnMount,
      animateOnToggle: animateOnToggle,
      hasRendered: hasRendered,
      arrowColor: arrowColor,
      arrowSize: arrowSize,
      className: className,
      content: content,
      id: id,
      open: open,
      placement: this.getPlacement(),
      ref: this.contentRefCallback,
      style: style,
      use: use,
      width: width
    });
  },
  render: function render() {
    var _props5 = this.props,
        arrowSize = _props5.arrowSize,
        _bodyElement = _props5._bodyElement,
        _distanceAdjustment = _props5._distanceAdjustment,
        _insetAdjustment = _props5._insetAdjustment,
        rest = _objectWithoutProperties(_props5, ['arrowSize', '_bodyElement', '_distanceAdjustment', '_insetAdjustment']);

    var isVisible = this.state.isVisible;

    var arrowParams = this.getArrowParams();

    return _react2.default.createElement(
      _UIAbstractPopup2.default,
      _extends({}, rest, {
        bodyElement: _bodyElement,
        center: arrowSize !== 'none',
        content: this.renderPopoverContent(),
        distance: arrowParams.distance + _distanceAdjustment,
        inset: arrowParams.inset + _insetAdjustment,
        onTetherUpdate: this.handleTetherUpdate,
        open: isVisible,
        placement: this.getPlacement(),
        ref: this.popupRefCallback }),
      this.props.children
    );
  }
});

exports.default = (0, _Controllable2.default)(UIPopover, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.348/js/tooltip/UIPopover.js
// module id = 257
// module chunks = 0 1